"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asScoreApiParams = exports.asSortingOrder = exports.asScoreSorting = exports.asScoreFormat = exports.asPassportStats = exports.asPassportMetadata = exports.asSkinMetadata = exports.asScoresResponse = exports.asApiScoreAttribute = exports.asScore = exports.asScoreMetadata = exports.asScoreCategories = exports.asCategoryProperties = exports.asScoreExplanation = void 0;
const ethereum_1 = require("@restless/ethereum");
const sanitizers_1 = require("@restless/sanitizers");
const asRecord_1 = require("./asRecord");
exports.asScoreExplanation = (0, sanitizers_1.asObject)({
    id: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    suggestion: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    explanation: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    impact: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    source: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    timestamp: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    transactionId: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
});
exports.asCategoryProperties = (0, sanitizers_1.asObject)({
    title: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    description: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    uri: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
});
exports.asScoreCategories = (0, asRecord_1.asRecord)(exports.asCategoryProperties);
exports.asScoreMetadata = (0, sanitizers_1.asObject)({
    rank: sanitizers_1.asNumber,
    percentile: sanitizers_1.asNumber,
    explanations: (0, sanitizers_1.asArray)(exports.asScoreExplanation),
});
exports.asScore = (0, sanitizers_1.asObject)({
    account: sanitizers_1.asString,
    protocol: sanitizers_1.asString,
    score: sanitizers_1.asString,
    epoch: (0, sanitizers_1.asOptional)(sanitizers_1.asNumber),
    metadata: (0, sanitizers_1.asOptional)(exports.asScoreMetadata),
    merkleProof: (0, sanitizers_1.asOptional)((0, sanitizers_1.asArray)(sanitizers_1.asString)),
});
exports.asApiScoreAttribute = (0, sanitizers_1.asObject)({
    name: sanitizers_1.asString,
    nameByte32: sanitizers_1.asString,
    active: sanitizers_1.asBoolean,
    title: sanitizers_1.asString,
    description: sanitizers_1.asString,
    externalUri: sanitizers_1.asString,
    sources: (0, sanitizers_1.asArray)(sanitizers_1.asString),
    categories: exports.asScoreCategories,
    defaults: (0, sanitizers_1.asArray)(exports.asScoreExplanation),
    max: sanitizers_1.asString,
    min: sanitizers_1.asString,
    ranges: (0, sanitizers_1.asArray)((0, sanitizers_1.asArray)(sanitizers_1.asString)),
    populations: (0, sanitizers_1.asArray)(sanitizers_1.asString),
});
exports.asScoresResponse = (0, sanitizers_1.asObject)({
    total: sanitizers_1.asNumber,
    current: sanitizers_1.asNumber,
    limit: sanitizers_1.asNumber,
    offset: sanitizers_1.asNumber,
    data: (0, sanitizers_1.asArray)(exports.asScore),
});
exports.asSkinMetadata = (0, sanitizers_1.asObject)({
    title: sanitizers_1.asString,
    group: sanitizers_1.asString,
    description: sanitizers_1.asString,
    name: sanitizers_1.asString,
    contract: ethereum_1.asEthAddress,
    tokenIds: (0, sanitizers_1.asArray)(sanitizers_1.asString),
    imageUrl: sanitizers_1.asString,
    videoUrl: sanitizers_1.asString,
    chainId: sanitizers_1.asString,
});
exports.asPassportMetadata = (0, sanitizers_1.asObject)({
    address: sanitizers_1.asString,
    status: (0, sanitizers_1.asEnum)(['active', 'unclaimed'], 'PassportMetadataStatus'),
    imageUrlFront: sanitizers_1.asString,
    imageUrlBack: sanitizers_1.asString,
    videoUrl: sanitizers_1.asString,
    activeSkin: (0, sanitizers_1.asOptional)(exports.asSkinMetadata),
    dateIssued: sanitizers_1.asNumber,
    creditHistory: (0, asRecord_1.asRecord)(sanitizers_1.asString),
});
exports.asPassportStats = (0, sanitizers_1.asObject)({
    passports: ethereum_1.asBigNumber,
    customScores: ethereum_1.asBigNumber,
});
exports.asScoreFormat = (0, sanitizers_1.asEnum)(['simple', 'full', 'proof'], 'ScoreFormat'); // 'admin' is not exposed
exports.asScoreSorting = (0, sanitizers_1.asEnum)(['rank', 'account'], 'ScoreSorting');
exports.asSortingOrder = (0, sanitizers_1.asEnum)(['asc', 'desc'], 'SortingOrder');
exports.asScoreApiParams = (0, sanitizers_1.asObject)({
    account: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    protocol: (0, sanitizers_1.asOptional)(sanitizers_1.asString),
    limit: (0, sanitizers_1.asOptional)(sanitizers_1.asNumber),
    offset: (0, sanitizers_1.asOptional)(sanitizers_1.asNumber),
    greaterThan: (0, sanitizers_1.asOptional)(sanitizers_1.asNumber),
    lessThan: (0, sanitizers_1.asOptional)(sanitizers_1.asNumber),
    format: (0, sanitizers_1.asOptional)(exports.asScoreFormat),
    sortBy: (0, sanitizers_1.asOptional)(exports.asScoreSorting),
    sortOrder: (0, sanitizers_1.asOptional)(exports.asSortingOrder),
});
//# sourceMappingURL=asScore.js.map